import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { UntypedFormGroup, UntypedFormArray, UntypedFormBuilder, Validators } from "@angular/forms";
import { Observable } from "rxjs";
import { pillar } from "../models/pillar.model";
import { ActivityModelNew} from "../models/newChanges";
import { CommonActivityService } from "./common-activity.service";


import { environment } from "../../../environments/environment";
import { activityInput } from "../models";


@Injectable()
export class ReportCalculateService {
  private readonly W2_Q1 = "w2-q1";
  private readonly W2_Q2 = "w2-q2";
  private readonly W5_Q1= "w5-q1";
  private readonly W5_Q2= "w5-q2";

  private readonly W6_Q1= "w6-q1";
  private readonly W6_Q2= "w6-q2";
  public calServiceurl: string = environment.gsfCalculationURL;
  public activityInput: activityInput;
  constructor(
    private readonly _http: HttpClient,
    private readonly fb: UntypedFormBuilder,
  ) {}

  createQuestionFormGroup(question): UntypedFormGroup {
    const questionForm: UntypedFormGroup = this.fb.group({
      inputList: this.fb.array([]),
    });

    question.inputList.forEach((input) => {
      if (input.type) {
        (questionForm.get("inputList") as UntypedFormArray).push(
          this.getFormControl(input)
        );
      }
    });

    return questionForm;
  }

  getCalculateResult(inputListQuestionWise): Observable<any> {
    const fetchUrl = `${this.calServiceurl}gsf/api/calculate`;

    return this._http.post(fetchUrl, inputListQuestionWise);
  }

  getPillarQuestions(pillarName, lang, year: number): Observable<pillar> {
    const URL = `${this.calServiceurl}gsf/api/calculate/qusConfigJson/${pillarName}/${lang}`;
    return this._http.get<pillar>(URL);
  }

  getPillarList(): Observable<any> {

    const URL = `${this.calServiceurl}gsf/api/calculate/pillars`;

    return this._http.get(URL);
  }
  getFormControl(input) {
    if (input.isRequired && input.isRequired === "true") {
      return this.fb.control("", Validators.required);
    } else {
      return this.fb.control("");
    }
  }

  getDependedQusConfigs(): Observable<any> {

    const URL =  `${this.calServiceurl}gsf/api/calculate/getDependedQusConfig`;

    return this._http.get(URL);
  }

  updateDependencyStatus(activity: ActivityModelNew, dependedConfig) {
    if (
      activity.hasDependency &&
      dependedConfig &&
      dependedConfig[activity.id]
    ) {
      dependedConfig[activity.id].hasAnswer = true;
    }
  }

  populateDependValues(selectedValue, inputObj, inputList): void {
    if (inputObj.dependancy.flag) {
      const deptId = inputObj.dependancy.depId;

      this.populate(deptId, selectedValue, inputList);
    }
    if (inputObj.hasSecondDep && inputObj.hasSecondDep.flag) {
      const deptId = inputObj.hasSecondDep.depId;
      this.populate(deptId, selectedValue, inputList);
    }
  }

  populate(deptId, selectedValue, inputList) {
    inputList.forEach((obj) => {
      if (obj.inputControlID === deptId) {
        obj.values = obj[selectedValue];
      }
    });
  }
  private hasTableQusAns(gsfDetailsQusWise) {
    return (
      gsfDetailsQusWise[this.W2_Q1] ||
      gsfDetailsQusWise[this.W2_Q2] ||
      gsfDetailsQusWise[this.W5_Q1] ||
      gsfDetailsQusWise[this.W5_Q2] ||
      gsfDetailsQusWise[this.W6_Q1] ||
      gsfDetailsQusWise[this.W6_Q2]
    );
  }


}
